import {
  LhcItemMutation,
  LhcItemMutationsResponse,
} from '@diamond/shared/types';

/**
 * Fake mutation data for LHC Item Mutations search
 * Based on Image 2 design - 4 sample records
 *
 * Toggle usage in use-collection-mutations.ts:
 * - Import this mock function
 * - Set USE_MOCK_MUTATIONS = true to enable
 */

const FAKE_MUTATION_DATA: LhcItemMutation[] = [
  {
    id: 'mock-mutation-1',
    mutation_no: '2512010001',
    mutation_date: 1733062800,
    amount: 210000,
    bank_name: 'BCA',
    memo_line:
      '0109/FTSCY/WS95271.210000.00SUSU 1 KARTON - 6030968822 IDR - DR Firman Wahyuni',
    remark: null,
    used_amount: 0,
    remaining_amount: 210000,
    is_fully_used: false,
    usage_summary: null,
  },
  {
    id: 'mock-mutation-2',
    mutation_no: '2512010002',
    mutation_date: 1733062800,
    amount: 2200000,
    bank_name: 'BCA',
    memo_line:
      '0109/FTSCY/WS95271.210000.00SUSU 1 KARTON - 6030968822 IDR - DR Firman Wahyuni',
    remark: null,
    used_amount: 1560000,
    remaining_amount: 640000,
    is_fully_used: false,
    usage_summary: 'Digunakan 3 LHC, 4 SJ',
  },
  {
    id: 'mock-mutation-3',
    mutation_no: '2512010002',
    mutation_date: 1733062800,
    amount: 2200000,
    bank_name: 'BCA',
    memo_line:
      '0109/FTSCY/WS95271.210000.00SUSU 1 KARTON - 6030968822 IDR - DR Firman Wahyuni',
    remark: null,
    used_amount: 2200000,
    remaining_amount: 0,
    is_fully_used: true,
    usage_summary: 'Habis digunakan',
  },
  {
    id: 'mock-mutation-4',
    mutation_no: '2512010003',
    mutation_date: 1733062800,
    amount: 1500000,
    bank_name: 'Mandiri',
    memo_line:
      '0109/FTSCY/WS95271.210000.00SUSU 1 KARTON - 6030968822 IDR - DR Firman Wahyuni',
    remark: null,
    used_amount: 1300000,
    remaining_amount: 200000,
    is_fully_used: false,
    usage_summary: 'Digunakan 1 LHC, 1 SJ',
  },
];

/**
 * Mock function that mimics the real searchLHCItemMutations API
 * Returns fake mutation data with simulated network delay
 *
 * @param _token - Auth token (ignored in mock)
 * @param _lhcId - LHC ID (ignored in mock)
 * @param _itemId - Item ID (ignored in mock)
 * @param _params - Search params (ignored in mock)
 * @returns Promise<LhcItemMutationsResponse> - Mock response with fake data
 */
export async function mockSearchLHCItemMutations(
  _token: string,
  _lhcId: string,
  _itemId: string,
  _params: Record<string, unknown>
): Promise<LhcItemMutationsResponse> {
  // Simulate network delay for realistic behavior
  await new Promise((resolve) => setTimeout(resolve, 300));

  return {
    data: FAKE_MUTATION_DATA,
    pagination: {
      rows: 4,
      pages: 1,
    },
    total: 4,
    total_items: 4,
  };
}

